module.exports = __webpack_public_path__ + "static/media/blueShirt.5753af09.jpg";